import initProductsSlider from '../sliders/products-slider';

/**
 * Init Tabs
 */
const initTabs = () => {
    const activeTabClass = 'is-current';

    $('.js-tabs .tabs__nav a').on('click', function(event) {
        const $tabLink = $(this);
        const $targetTab = $($tabLink.attr('href'));
        const $slider = $targetTab.find('.js-slider');

        // Init slider in tab
        if ($slider.length > 0 && $slider.find('.slick-initialized').length === 0) {
            initProductsSlider($slider.find('.slider__slides'));
        }

        $tabLink
            .parent()
            .add($targetTab)
            .addClass(activeTabClass)
                .siblings()
                .removeClass(activeTabClass);

        event.preventDefault();
    });
}

initTabs();
